export const modalPadding = '48px'
